import { Navigate } from "react-router-dom";

export default function Join() {
  // Redirect to external URL using window.location
  // This component will render briefly but immediately redirect
  if (typeof window !== "undefined") {
    window.location.href = "https://forms.studio/_7mdH1URnHV62u8bPxbuz";
  }

  return null;
}
